////
/// ============================================================================
/// COMPONENT / Notify Bar
/// ============================================================================
///
/// @group components
////

import "../vendors/cookie-manager";

export default () => {

    window.$ = jQuery;

    var banner;

    // delay = (function () {
    //     var timer = 0;
    //
    //     return function (callback, ms) {
    //         clearTimeout(timer);
    //         timer = setTimeout(callback, ms);
    //     };
    // }());

    banner = {
        options: {
            element: $('.js-notifybar'),
            delay: 5000,
            elementToMove: $('.footer')
        },

        cookieName: 'banner',

        init: function () {
            banner.$el = banner.options.element;
            banner.$toggle = banner.$el.find('.notifybar__toggle');
            // banner.$window = $(window);

            banner.initialClass = banner.$el.hasClass('notifybar--open') ? 'notifybar--open' : 'notifybar--close';
            banner.opened = banner.initialClass === 'notifybar--open';
        },

        start: function () {
            banner.$toggle.on('click', banner.onToggleClick);
            banner.$el.on('transitionend', banner.onTransitionEnd);

            var cookieValue = cookieManager.read(banner.cookieName);

            if (cookieValue === 'notifybar--close') {
                banner.$el.removeClass('notifybar--open').addClass('notifybar--close');
            } else {
                setTimeout(banner.open, banner.options.delay);
            }

            // banner.$window.on('resize', banner.onWindowResize);
        },

        onToggleClick: function () {
            if (banner.$el.hasClass('notifybar--open')) {
                banner.close();
            } else {
                banner.open();
            }
        },

        // onWindowResize: function () {
        //     delay(function () {
        //         if (banner.$el.hasClass('notifybar--open')) {
        //             banner.calculateHeight();
        //         }
        //     }, 300);
        // },

        open: function () {
            //console.log('notify open');

            if (banner.opened) {
                return;
            }

            banner.calculateHeight();

            banner.$el.height(0).removeClass('notifybar--close').addClass('notifybar--open').height(banner.height);
            cookieManager.erase(banner.cookieName);

            if (banner.options.elementToMove) {
                banner.options.elementToMove.css('marginBottom', banner.height);
            }

            banner.opened = true;
        },

        close: function () {
            // console.log('notify close');

            if (!banner.opened) {
                return;
            }

            banner.calculateHeight();

            banner.$el.height(banner.height).removeClass('notifybar--open').addClass('notifybar--close').height(0);
            cookieManager.create(banner.cookieName, 'notifybar--close', 7);

            if (banner.options.elementToMove) {
                banner.options.elementToMove.css('marginBottom', 0);
            }

            banner.opened = false;
        },

        destroy: function () {
            banner.$el
                .removeAttr('style')
                .removeClass('notifybar--open notifybar--close')
                .addClass(banner.initialClass);

            banner.$toggle.off('click', banner.onToggleClick);
            banner.$el.off('transitionend', banner.onTransitionEnd);
            // banner.$window.off('resize', banner.onWindowResize);

            if (banner.options.elementToMove) {
                banner.options.elementToMove.removeAttr('style');
            }
        },

        onTransitionEnd: function () {
            banner.$el.removeAttr('style');
        },

        calculateHeight: function () {
            var clone = banner.$el.clone();

            clone.show().css('height', 'auto').insertAfter(banner.$el);
            banner.height = clone.height();
            clone.remove();

            // console.log(banner.height);
        },

        // ,
        //
        // cookie: {
        //     create: function (name, value, days) {
        //         var date, expires;
        //
        //         if (days) {
        //             date = new Date();
        //             date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        //             expires = "; expires=" + date.toUTCString();
        //         } else {
        //             expires = '';
        //         }
        //
        //         document.cookie = name + '=' + value + expires + '; path=/';
        //     },
        //     read: function (name) {
        //         var
        //             nameEQ = name + '=',
        //             ca = document.cookie.split(';'),
        //             i, l = ca.length, c;
        //
        //         for (i = 0; i < l; i++) {
        //             c = ca[i];
        //
        //             while (c.charAt(0) === ' ') {
        //                 c = c.substring(1, c.length);
        //             }
        //
        //             if (c.indexOf(nameEQ) === 0) {
        //                 return c.substring(nameEQ.length, c.length);
        //             }
        //         }
        //
        //         return null;
        //     }
        // }
    };

    banner.init();

    // if (Modernizr.mq('(min-width: 768px)')) {
    //     // desktop
    //     banner.start;
    // } else {
    //     // mobile
    //     banner.destroy;
    // }
    banner.start();

};
